import { BRANDSETTINGS } from "constants/action-types";

export const updateImageFormats = (imageFormats) => ({
    payload: imageFormats,
    type: BRANDSETTINGS.IMAGE_FORMATS.UPDATE.START,
});
